export enum QuizTimeoutHandlingType {
  CALCULATE_RESULT = 'CALCULATE_RESULT',
  DO_NOT_CALCULATE_RESULT = 'DO_NOT_CALCULATE_RESULT'
}
